import { render } from "./MarkerScene.vue?vue&type=template&id=95e435d8&scoped=true"
import script from "./MarkerScene.vue?vue&type=script&lang=js"
export * from "./MarkerScene.vue?vue&type=script&lang=js"

import "./MarkerScene.vue?vue&type=style&index=0&id=95e435d8&scoped=true&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e435d8"]])

export default __exports__